<template>
    <div>
        <compWrapper :title="$t('global.common.base_information',{defaultValue:'基本信息'})" theme="primary">
            <compFormQuery
				class="margin-layout"
				:formdata="getBase"
				:value="formData"
				placeholder="--"
			></compFormQuery>
        </compWrapper>
        <compWrapper title="报价明细" theme="info">
            <div class="margin-15">
                <Button v-if="type != 'query'" type="primary" class="margin-bottom-10" @click="addItem">添加</Button>
                <Table
                    :columns="columns"
                    :data="datalist"
                    size="small"
                    ref="table"
                    border
                ></Table>
            </div>
        </compWrapper>
        <div v-if="type!='query'" class="text-right">
            <Button @click="cancel">返回</Button>
        </div>
        <!-- 使用公共弹框 -->
        <compModal
			v-model="modalProps.show"
			v-bind="modalProps"
            @on-close="modalProps={}"
		>
            <component ref="cusref" :is="modalProps.component" v-bind="modalProps" v-on="modalProps.on" @on-close="modalProps={}"></component>
        </compModal>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import { HttpGetCustomerPriceOneOrg,HttpGetCustomerPriceTable,DeleteCustomerPriceOneDetail } from '@/service/product';
import comDetail from './alertdetail'
import { mapGetters } from 'vuex';

export default {
    props:['activeid','type'],
    components:{
        comDetail
    },
    data(){
        return {
            type: this.$route.params.type || this.type,
            headId: this.$route.query.id || this.activeid,
            id:'',
            formData:{},
            modalProps:{},
            datalist:[],
            loading:false,
        }
    },
    created(){
        this.getDetail();
    },
    computed:{
        ...mapGetters('dictionary', ['getSelfmanageorgList']),
        getBase(){
            return [
                {
                    label: "客户公司名称",
                    key: "companyName",
                },
                {
                    label: "客户组织名称",
                    key: "orgId",
                    tag:'Select',
                    options:this.getSelfmanageorgList
                },
            ]
        },
        columns(){
            let array = [
                {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    width: 140,
                    render:(h, { row, index })=>{
                    return h('div', [
                        h('Button', {
                            props: {
                                type: "primary",
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    this.changeEdit(row.id,row.headId)
                                }
                            }
                        }, this.$t('global.common.operation_edit', { defaultValue: '编辑' })),
                        h('Button', {
                            props: {
                                type: "error",
                                size: 'small'
                            },
                            on: {
                                click: () => {
                                    this.comremove(row.id)
                                }
                            }
                        }, this.$t('global.common.delete', { defaultValue: '删除' }))
                    ])

                    }
                },
                {
                    title: "报价开始日期",
                    key:'startDate'
                },
                {
                    title: "报价结束日期",
                    key:'endDate'
                },
                {
                    title: "库内毛利率",
                    key:'warehouseGpm',
                    render:(h,{row})=>{
                        return <div>{row.warehouseGpm}%</div>
                    }
                },
                {
                    title: "尾程毛利率",
                    key:'tailGpm',
                    render:(h,{row})=>{
                        return <div>{row.tailGpm}%</div>
                    }
                },
                {
                    title: "附件",
                    key:'attachment',
                    render:(h,{row})=>{
                        return row.attachment.map(item=>{
                            console.log(item)
                            return <div>
                                <a class="color-primary" onClick={this.downloadExl.bind(this, item)}>{item.name}</a>
                            </div>
                        })
                    }
                },
                {
                    title: "备注",
                    key:'remark'
                },
                {
                    title: "更新时间",
                    key:'updatedAt'
                },
                
            ]
            if(this.type=='query'){
                array.splice(0,1)
            }
            return array
        }
    },
    methods:{
        getDetail(){
            // 请求组织查看详情
            HttpGetCustomerPriceOneOrg({
                id:this.headId
            }).then(res=>{
                this.formData = res.data
            },err=>{
                this.$Message.error({
                    content:err.message,
                    duration:10,
                    closable:true,
                })
            })
            // 请求报价明细详情
            HttpGetCustomerPriceTable({
                headId:this.headId
            }).then(res=>{
                this.datalist = res.data.content;
            },err=>{
                this.$Message.error({
                    content:err.message,
                    duration:10,
                    closable:true,
                })
            })
        },
        addItem(){
            this.modalProps = {
                show:true,
                title: '添加报价明细',
                component: "comDetail",
                width:500,
                showFooter:false,
                id:this.id,
                headId:this.headId,
                on:{
                    'on-row':(row)=>{
                        this.getDetail()
                    }
                }
            }
        },
        changeEdit(id,headId){
            this.modalProps = {
                show:true,
                title: '编辑报价明细',
                component: "comDetail",
                width:500,
                showFooter:false,
                id:id,
                headId:headId,
                type:'edit',
                on:{
                    'on-row':(row)=>{
                        this.getDetail()
                    }
                }
            }
        },
        comremove(id){
            this.modalProps = {
				show: true,
				title: this.$t('global.common.delete', { defaultValue: '删除' }),
				alert: 'warning',
                params: { id: id },
				ajaxRequest: DeleteCustomerPriceOneDetail,
                callback:()=>{
                    // 重新刷新页面
                    this.getDetail()
                }
			}
        },
        downloadExl(val){
            console.log(val)
            this.handleWebfs(val.url, {}, 'download')
        },
        cancel(){
            this.$router.push({
				name: 'customerpriceList'
			})
        }
    }
}
</script>

